import {
  GetComponentFileInDto,
  GetComponentFileOutDto,
} from "../../../types/course.dto";

export const GET_COMPONENT_FILE = "GET_COMPONENT_FILE";
export const GET_COMPONENT_FILE_SUCCESS = "GET_COMPONENT_FILE_SUCCESS";
export const GET_COMPONENT_FILE_ERROR = "GET_COMPONENT_FILE_ERROR";
export const RESET_GET_COMPONENT_FILE = "RESET_COMPONENT_FILE_STATICS";

export interface GetComponentFile {
  type: typeof GET_COMPONENT_FILE;
  payload: GetComponentFileOutDto;
}

export interface GetComponentFileSuccess {
  type: typeof GET_COMPONENT_FILE_SUCCESS;
  payload: GetComponentFileInDto;
}

export interface GetComponentFileError {
  type: typeof GET_COMPONENT_FILE_ERROR;
  payload: any;
}

export interface ResetGetComponentFile {
  type: typeof RESET_GET_COMPONENT_FILE;
  payload: null;
}

export interface State {
  data: GetComponentFileInDto | null;
  states: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
};

export type Actions =
  | GetComponentFile
  | GetComponentFileSuccess
  | GetComponentFileError
  | ResetGetComponentFile;
